import type { AppEnvironment, EnvironmentFeatures } from './environment.types';

const features: EnvironmentFeatures = {
  trustBar: true,
  problem: true,
  idealState: true,
  solution: true,
  features: true,
  problemSolutionResult: true,
  portfolio: true,
  serviceDirections: true,
  webSupervision: true,
  pricing: true,
  process: true,
  quoteRequest: true,
  whyUs: true,
  faq: true,
  contactForm: true,
};

export const environment: AppEnvironment = {
  production: false,
  apiUrl: '',
  tenantSlug: 'allindev',
  branding: {
    primaryColor: '#1a2744',
    secondaryColor: '#2563eb',
  },
  features,
};
